<style lang="less" scoped>
    .team-container {
        .list-container {
            height: 100%;
            .ivu-col {
                height: 100%;
                overflow: auto;
            }
            .col {
                display: inline-block;
                vertical-align: top;
                height: 100%;
                overflow: auto;
            }
            .col-left {
                width: 40%;
            }
            .col-right {
                width: 60%;
            }
        }
        /deep/ .ivu-tree-title{
            width: 100%;
        }
        /deep/ .team-row{
            font-size: 12px;
            .team-name{
                display: inline-block;
                height: 24px;
                line-height: 24px;
                padding-left: 5px;
            }
            .text-name-text{
                display: inline-block;
                vertical-align: top;
                max-width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &:hover {
                background-color: #e5e5e5;
            }
        }
        /deep/ .team-hl{
            &:hover {
                color: #2D8cF0;
            }
        }
        /deep/ .ivu-tree ul li{
            margin: 2px 0;
        }
        /deep/ .ivu-btn-small{
            font-size: 12px;
        }
    }
</style>
<template>
  <div
    class="team-container"
    :style="container_style"
  >
    <div class="list-container">
      <div class="col col-left">
        <div style="padding:0 25px;text-align:right">
          <Button
            size="small"
            type="primary"
            style="margin-right:10px"
            @click="foldAll(false)"
          >
            全部折叠
          </Button>
          <Button
            size="small"
            type="primary"
            @click="foldAll(true)"
          >
            全部展开
          </Button>
        </div>
        <TreeNew
          :tree-data="tree_teams"
          :tree-call-back-obj="treeCallBackObj"
          :have-extra-button="true"
        />
        <Backdrop v-show="loading" />
      </div><div class="col col-right">
        <div
          v-if="cur_team.name"
          class="line"
        >
          <span class="text-large text-bold">{{ cur_team.full_name }} <small>共{{ page_info.total }}人</small></span>
          <Button
            size="small"
            @click="setTeam"
          >
            设置团队
          </Button>
          <i-input
            v-model="params.search"
            size="small"
            clearable
            style="width: 180px"
            placeholder="搜索员工: 姓名，邮箱，手机"
            @on-clear="queryCustomer"
            @on-enter="queryCustomer"
          />
          <Button
            size="small"
            @click="queryCustomer"
          >
            搜索
          </Button>
        </div>
        <Table
          size="small"
          :columns="customer_columns"
          :data="customers"
          :loading="customer_loading"
          @on-selection-change="selectChange"
        />
        <Page
          v-show="customers.length"
          class="line"
          size="small"
          show-total
          show-elevator
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>
    </div>

    <Modal
      v-model="edit_config.modal"
      width="600"
      title="添加 / 修改"
      ok-text="保存"
      :loading="edit_config.loading"
      @on-ok="editOK"
    >
      <Form
        ref="teamForm"
        :model="edit_team"
        :label-width="80"
      >
        <Form-item
          label="父团队"
          prop="parent_id"
        >
          <Select
            v-model="edit_team.parent_id"
            placeholder="选择父团队"
            @on-change="parentTeamChange"
          >
            <Option :value="0">
              无
            </Option>
            <Option
              v-for="team in select_teams"
              v-show="!team.del"
              :key="team.id"
              :value="team.id"
            >
              {{ team.name }}
            </Option>
          </Select>
        </Form-item>
        <Form-item
          label="团队级别"
          prop="level"
        >
          <Select
            v-model="edit_team.level"
            :disabled="!!edit_team.parent_id"
            placeholder="选择团队级别"
          >
            <Option :value="0">
              0级 特殊团队，不参与审核
            </Option>
            <Option :value="1">
              1级 团队级
            </Option>
            <Option :value="2">
              2级 TL级
            </Option>
            <Option :value="3">
              3级
            </Option>
            <Option :value="4">
              4级
            </Option>
            <Option :value="5">
              5级
            </Option>
          </Select>
        </Form-item>
        <Form-item
          label="团队名称"
          prop="name"
        >
          <i-input
            v-model="edit_team.name"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item
          label="负责人"
          prop="leader_id"
        >
          <CustomerSelector
            v-for="(leader, index) in edit_team.leaders"
            :key="`${leader.id}_${index}`"
            style="display: inline-block; width: auto; margin-right: 5px"
            transfer
            deletable
            @on-change="setLeader(leader, ...arguments)"
            @on-delete="delLeader(leader, index)"
          >
            <div v-if="leader.id">
              {{ leader.account }}
            </div>
            <div
              v-else
              class="color-grey"
            >
              请选择
            </div>
          </CustomerSelector>
          <Button
            icon="md-add"
            @click="addTeamLeader"
          >
            添加
          </Button>
        </Form-item>
        <Form-item
          label="团队图片"
          prop="avatar"
        >
          <FileUploader
            :data="{id: edit_team.id}"
            :upload_path="upload_team_avatar_path"
            :format="['jpg', 'jpeg', 'png']"
            @done="uploadedAvatar"
          >
            <div>
              <img
                v-if="edit_team.avatar"
                :src="fileUrl(edit_team.avatar)"
              >
              <Icon
                v-else
                type="ios-people-outline"
                color="#aaaaaa"
                size="120"
              />
            </div>
          </FileUploader>
        </Form-item>
        <Form-item
          label="备注"
          prop="desc"
        >
          <i-input
            v-model="edit_team.desc"
            type="textarea"
            placeholder="备注..."
          />
        </Form-item>
      </Form>
    </Modal>

    <Modal
      v-model="customer_config.modal"
      width="600"
      ok-text="保存"
      :loading="customer_config.loading"
      @on-ok="setTeamOk"
    >
      <div
        slot="header"
        class="text-bold text-large"
      >
        团队批量设置为: {{ select_team.full_name }}
      </div>
      <TreeNew
        :tree-data="tree_teams"
        :tree-call-back-obj="modalTreeCallBackObj"
      />
    </Modal>
  </div>
</template>
<script route="/hr/team">
  import Util from '../../libs/util';
  import CustomerUtil from './libs/util';
  import CustomerSelector from '../components/customer/selector';
  import FileUploader from '../components/file/uploader';
  import TreeNew from './TreeNew/index.vue'
  export default {
    /* router_info_start */
    router_info: '/hr/team',
    /* router_info_end */

    components: { FileUploader, CustomerSelector, TreeNew },
    data() {
      return {
        team_columns: [
          {
            title: '团队编号',
            align: 'center',
            render(h, params) {
              let code = '';
              const id = params.row.id.toString();
              for (let i = 0; i < (4 - id.length); i++) {
                code += '0';
              }
              code += id;
              return h('span', code);
            }
          },
          {
            title: '名称',
            key: 'name',
            align: 'center',
            render(h, params) {
              let name = params.row.name;
              if (params.row.del) {
                name += ' (已废弃)';
              }
              return h('span', name);
            }
          },
          {
            title: 'Leader',
            key: 'leader',
            align: 'center',
            render(h, params) {
              return h('span', params.row.leader_account);
            }
          },
          {
            title: '父团队',
            key: 'parent_id',
            align: 'center',
            render:(h, params) => {
              const row = params.row;
              const parent = this.teams_hash[row.parent_id];
              if (parent) {
                return h('span', parent.name);
              } else {
                return h('span', '无');
              }
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'desc',
          },
          {
            title: '操作',
            key: 'action',
            fixed: 'right',
            align: 'center',
            width: 150,
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h('Button', {
                  on: {
                    click: () => {
                      this.editTeam(row);
                    }
                  }
                }, '修改'),
                h('Button', {
                  on: {
                    click: () => {
                      this.editTeamAvatar(row);
                    }
                  }
                }, 'Logo'),
              ];
              if (!row.del) {
                ret.push(h('Button', {
                  on: {
                    click: () => {
                      this.deleteTeam(row);
                    }
                  }
                }, '废弃'));
              }
              return h('ButtonGroup', {
                props: {
                  size: 'small'
                }
              }, ret);


              /* let ret = [];
                            ret.push(h('Button', {
                                props: {
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.editTeam(params.row);
                                    }
                                }
                            }, '修改'));
                            if(!params.row.del){
                                ret.push(h('Button', {
                                    props: {
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteTeam(params.row);
                                        }
                                    }
                                }, '废弃'));
                            }
                            return h('div', ret); */
            }
          }
        ],
        team_validate: {
          name: [
            { required: true, message: '名称不能为空', trigger: 'blur' }
          ],
          leader_id: [
            { required: true, message: '请指定负责人', trigger: 'change' }
          ]
        },
        //tree_info: {top_teams: [], level_teams_hash: {}},
        tree_teams: [],
        teams: [],
        teams_hash: [],
        level_teams_hash: {},
        hl_team_ids: [],
        empty_tip: '获取数据中...',
        loading: false,
        edit_config: {
          modal: false,
          loading: true
        },
        upload_team_avatar_path: Util.api.upload_team_avatar,
        new_team: {
          name: '',
          parent_id: 0,
          level: 1,
          desc: '',
          leaders: [],
          avatar: ''
        },
        edit_team: {},
        searched_customers: [],
        search_customer_loading: false,
        button_props: {
          type: 'default',
          size: 'small',
        },
        cur_team: {},
        customer_loading: false,
        customers: [],
        customer_columns: [
          {
            type: 'selection',
            width: 35,
            align: 'center'
          },
          {
            title: '姓名',
            key: 'account',
            width: 80,
            align: 'center'
          },
          {
            title: '团队',
            key: 'team',
            align: 'center'
          },
          {
            title: '员工类型',
            key: 'customer_type',
            width: 100,
            align: 'center',
            render: (h, params) => {
              const customer = params.row;
              return h('span', CustomerUtil.customerTypeName(customer.customer_type));
            }
          },
          {
            title: '邮箱',
            key: 'email',
            width: 180,
            align: 'center'
          },
          {
            title: '手机',
            key: 'mobile',
            width: 100,
            align: 'center'
          }
        ],
        params: {
          search: '',
          team_id: 0,
          page: 1,
          per_page: 20
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        customer_config: {
          modal: false,
          loading: true
        },
        select_customer_ids: [],
        select_team: {},
        root_team: {
          id: 0,
          name: '超有爱集团',
          expand: true,
          children: [],
        },
      }
    },
    computed: {
      select_teams() {
        const edit_level = this.edit_team.level;
        const select_level = edit_level - 1;
        const teams = this.level_teams_hash[select_level];
        return teams ? teams : [];
      },
      container_style() {
        return {
          height: `${this.$store.state.window_height - 136}px`
        }
      },
      treeCallBackObj() {
        return {
          selectedItem: this.showTeamCustomers,
          add:(data) => {
            this.addTeam(this.new_team, data) // 新增团队
          },
          edit:this.editTeam,
          del:this.deleteTeam
        }
      },
      modalTreeCallBackObj() {
        const _this = this
        return {
          selectedItem(data) {
            if (data.del) {
              _this.$Message.error('不能选择已经废弃的团队');
              return;
            }
            _this.select_team = data;
          }
        }
      }
    },
    created() {
      this.getTeams();
    },
    methods: {
      rowClassName(row) {
        if (row.del) {
          return 'row-grey';
        }
        return '';
      },
      customerTypeName(type) {
        return CustomerUtil.customerTypeName(type);
      },
      getTeams() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.team_tree_info, {

          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleTreeInfo(data.tree_info);
            } else {
              this.$Modal.error({title: '错误', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.error({title: '错误', content: e.message});
          }).finally(() => {
            this.loading = false;
          });
        }
      },
      handleTreeInfo({ top_teams = [], level_teams_hash } = {}) {
        const teams = [{
          id: 0,
          name: '超有爱集团',
          expand: true,
          children: top_teams,
        }]
        this.level_teams_hash = level_teams_hash;
        this.teams = [];
        this.tree_teams = this.handleTreeData(teams);
        this.root_team.children = this.tree_teams;
      },
      handleTreeData(teams, level = 0) {
        teams.forEach((team) => {
          if (team.children.length) {
            this.$set(team, 'expand', !level ? true : false);
          }
          this.teams.push(team);
          this.teams_hash[team.id] = team;
          this.handleTreeData(team.children, level + 1);
        });
        return teams;
      },
      parentTeamChange() {
        // setTimeout(() => {
        //     if (this.edit_team.parent_id === 0) {
        //         this.edit_team.level = 1;
        //     } else {
        //         const parent_team = this.teams_hash[this.edit_team.parent_id];
        //         this.edit_team.level = parent_team ? parent_team.level + 1 : 1;
        //     }
        // }, 500);
      },
      hlTeams(team) {
        this.hl_team_ids.push(team.id);
        const parent = this.teams_hash[team.parent_id];
        if (parent) this.hlTeams(parent);
      },
      isHlTeam(team) {
        return this.hl_team_ids.includes(team.id);
      },
      resetHlTeams() {
        this.hl_team_ids = [];
      },
      addTeam(team, parent) {
        this.edit_team = Util.clone(team);
        if (parent) {
          this.edit_team.parent_id = parent.id;
          this.edit_team.level = parent.level + 1;
        }
        // console.log('team:', this.edit_team, 'parent:', parent.id, parent.level);
        this.edit_config.modal = true;
      },
      editTeam(team) {
        this.edit_team = Util.clone(team);
        this.$nextTick(() => {
          this.edit_config.modal = true;
        })
      },
      addTeamLeader() {
        this.edit_team.leaders.push({id: 0, account: ''});
      },
      setLeader(leader, customer) {
        leader.id = customer.id;
        leader.account = customer.account;
      },
      delLeader(leader, index) {
        this.edit_team.leaders.splice(index, 1);
      },
      editOK() {
        this.edit_team.name = this.edit_team.name.trim();
        let valid = true;
        if (!this.edit_team.name) {
          valid = false;
          this.$Message.error('名称不能为空');
        }
        if (this.edit_team.level <= 1 && this.edit_team.leaders.length === 0) {
          valid = false;
          this.$Message.error('请指定负责人');
        }
        if (!valid) {
          this.resetEditLoading();
          return;
        }
        Util.ajax.post(Util.api.team_update, this.edit_team).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleTreeInfo(data.tree_info);
            this.$Message.success('提交成功!');
            this.edit_config.modal = false;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.resetEditLoading();
        });
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 1);
      },
      deleteTeam(team) {
        this.$Modal.confirm({
          title: '提示',
          content: `确定要废弃 ${team.name} 吗?`,
          onOk:() => {
            Util.ajax.post(Util.api.team_delete, team).then((response) => {
              return response.data;
            }).then((data) => {
              if (data.code === 1) {
                team.del = true;
              } else {
                setTimeout(() => {
                  this.$Modal.error({
                    title: '错误',
                    content: data.msg
                  });
                }, 600);
              }
            }).catch((e) => {
              this.$Message.error('废弃 team 失败: ' + e);
              console.log(e);
            });
          }
        });
      },
      showTeamCustomers(team) {
        this.cur_team = team;
        this.params.team_id = team.id;
        this.params.page = 1;
        this.params.search = '';
        this.select_team = {};
        this.select_customer_ids = [];
        this.queryCustomer();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.queryCustomer();
      },
      queryCustomer() {
        this.customer_loading = true;
        this.$util.ajax.get(this.$util.api.query_team_customer, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.customers = data.customers;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.customer_loading = false;
        });
      },
      selectChange(customers) {
        this.select_customer_ids = customers.map((c) => { return c.id });
      },
      setTeam() {
        if (!this.select_customer_ids.length) {
          this.$Modal.error({title: '错误', content: '请选择员工'});
          return;
        }
        this.customer_config.modal = true;
      },
      setTeamOk() {
        this.$util.ajax.post(this.$util.api.batch_set_customer_team, {
          team_id: this.select_team.id,
          customer_ids: this.select_customer_ids
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.customer_config.modal = false;
            this.queryCustomer();
            this.$Message.success('设置成功!');
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.resetCustomerLoading();
        });
      },
      resetCustomerLoading() {
        this.customer_config.loading = false;
        setTimeout(() => {
          this.customer_config.loading = true;
        }, 1);
      },
      uploadedAvatar(data) {
        this.edit_team.avatar = data.file;
      },
      fileUrl(filepath) {
        return Util.publicOSSUrl(filepath);
      },
      foldAll(type) {
        if (!(this.tree_teams[0] && this.tree_teams[0].children && this.tree_teams[0].children.length)) {
          return 
        }
        if (type) {
          this.tree_teams[0].expand = true
        }
        let stack = [...this.tree_teams[0].children]
        while (stack.length !== 0) {
          const current = stack.pop()
          current.expand = type
          stack = stack.concat(current.children)
        }
      }
    },
  }
</script>
